export const SET_INDUSTRIES_LIST_SUCCESS = 'SET_INDUSTRIES_LIST_SUCCESS';
export const GET_SIGNUP_REQUEST = 'GET_SIGNUP_REQUEST';
export const GET_SIGNUP_FAILED = 'GET_SIGNUP_FAILED';
export const SET_LOADING = 'SET_LOADING';
